var userAgent = require('../internals/engine-user-agent');
var global = require('../internals/global');

module.exports = /ipad|iphone|ipod/i.test(userAgent) && global.Pebble !== undefined;



//////////////////
// WEBPACK FOOTER
// ./~/core-js/internals/engine-is-ios-pebble.js
// module id = 1080
// module chunks = 0